// extracted by mini-css-extract-plugin
export default {"marginBottom2":"time-out_marginBottom2__BvAfH","marginBottom4":"time-out_marginBottom4__5h3Sl","error":"time-out_error__RHxeY"};